import { NgModule } from '@angular/core';
import { PluralSingularPipe } from '@core/pipes/plural-singular.pipe';
import { RemoveHtmlTagPipe } from './remove-html-tag.pipe';

@NgModule({
    declarations: [
        PluralSingularPipe,
        RemoveHtmlTagPipe
    ],
    exports: [
        PluralSingularPipe,
        RemoveHtmlTagPipe
    ]
})
export class CorePipesModule {

}
